import React from 'react';
import { useTranslation } from "react-i18next";
import ev_logo from '../../assets/ev_logo_white.png';

import './style.scss'



const LPageFooter = () => {
    const { t } = useTranslation()

    return <div className={'footer_container'}>
        <div className={'footer_container__logo'}>
            <img src={ev_logo} alt=""/>
        </div>
        <p>{t('powered_by')}</p>
    </div>
}

export default LPageFooter